import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { ConnectionStatusService } from '@services/connection-status.service';
import { OfflineNotificationService } from '@services/offline-notification.service';

export const ensureOnlineGuard: CanActivateFn = () => {
  if (inject(ConnectionStatusService).status() === 'common.online') {
    return true;
  }

  inject(OfflineNotificationService).notifyFeatureUnavailable();

  return inject(Router).createUrlTree([AppRoutes.login]);
};
